import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, FrameToComeActionTypes } from '@app/core/ngrx';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@app/shared/components';
import { FrameToComeService } from '@app/core/services';
@Component({
  selector: 'ecp-frame-to-ship',
  templateUrl: './frame-to-ship.component.html',
  styleUrls: ['./frame-to-ship.component.scss'],
})
export class FrameToShipComponent implements OnInit {
  @Input() frameToShipItems: any;
  @Input() cartId: any;
  constructor(
    public store: Store<AppState>,
    public dialog: MatDialog,
    private frameToComeService: FrameToComeService,
  ) {}

  ngOnInit(): void {}

  removeItem(i) {
    let frameInfo = this.frameToShipItems[i];
    this.dialog
      .open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        maxWidth: '89.3vw',
        maxHeight: '82vh',
        data: {
          content: `${frameInfo.brand} - ${frameInfo.style} (${frameInfo.color})`,
          title: `Remove this Frame?`,
          confirmBtnText: 'Ok',
          cancelBtnText: 'Cancel',
        },
      })
      .afterClosed()
      .subscribe(async confirm => {
        if (confirm) {
          if (frameInfo.cartItemId) {
            this.frameToComeService.removeCartDetails(frameInfo.cartItemId).subscribe(
              (res: any) => {
                this.store.dispatch({
                  type: FrameToComeActionTypes.REMOVE_FRAME_TO_COME,
                  payload: i,
                });
              },
              err => {
                this.store.dispatch({
                  type: FrameToComeActionTypes.REMOVE_FRAME_TO_COME,
                  payload: i,
                });
              },
            );
          } else {
            this.store.dispatch({
              type: FrameToComeActionTypes.REMOVE_FRAME_TO_COME,
              payload: i,
            });
          }
        }
      });
  }
}
